import React, { Component } from 'react';
import { TextField, Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import { withStyles } from '@material-ui/core/styles';
import * as validatorActions from '../../components/validator/store/actions'
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ComponentTrackingInfo from '../../components/ComponentTrackingInfo';
import { getSharedTextFieldProps } from '../../components/helpers';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    }
});

class QualificationForm extends Component {

    handleChange = field_name => event => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }
        const validator = {
            field_name, value
        }

        this.props.runValidator(validator);
        this.props.updateQualificationForm(update_data);
    }

    render() {
        const { classes, currentQualification, view_type, validator } = this.props

        const companyItems = this.props.allCompanies.map(c => {
            return (
                <MenuItem key={c.company_id} value={c.company_id}>{c.CompanyName}</MenuItem>
            )
        })

        return (
            <Grid container spacing={24}>
                <Grid item xs={6}>
                    <form style={styles.insidePaper} autoComplete="off">
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="QualificationName"
                                label="Qualification Name"
                                value={currentQualification.QualificationName}
                                onChange={this.handleChange('QualificationName')}
                                error={validator.filter(v => v.field_name === 'QualificationName')[0].error}
                                helperText={validator.filter(v => v.field_name === 'QualificationName')[0].error_msg}
                                {...getSharedTextFieldProps(view_type, classes)}
                                className={(currentQualification.QualificationName === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="QualificationDescription"
                                label="Description"
                                value={currentQualification.QualificationDescription}
                                onChange={this.handleChange('QualificationDescription')}
                                // error={validator.filter(v => v.field_name === 'CompanyName')[0].error}
                                {...getSharedTextFieldProps(view_type, classes)}
                                className={(currentQualification.QualificationDescription === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="QualificationText"
                                label="Qualification Text"
                                value={currentQualification.QualificationText}
                                onChange={this.handleChange('QualificationText')}
                                // error={validator.filter(v => v.field_name === 'CompanyName')[0].error}
                                {...getSharedTextFieldProps(view_type, classes)}
                                className={(currentQualification.QualificationText === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={(currentQualification.RequireAsset === 1)}
                                        onChange={(view_type === 'detail') ? undefined : this.handleChange('RequireAsset')}
                                        disableRipple={view_type === 'detail'}
                                        value="RequireAsset"
                                        color="primary"
                                    />
                                }
                                label="Requires Asset"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={(currentQualification.IsPublic === 1)}
                                        onChange={(view_type === 'detail') ? undefined : this.handleChange('IsPublic')}
                                        value="IsPublic"
                                        color="primary"
                                        disableRipple={view_type === 'detail'}
                                    />
                                }
                                label="Public"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel
                                    ref={ref => {
                                        this.InputLabelRef = ref;
                                    }}
                                    htmlFor="outlined-age-simple"
                                >
                                    Company
                                </InputLabel>
                                <Select
                                    value={currentQualification.company_id}
                                    onChange={this.handleChange('company_id')}
                                    input={
                                        <OutlinedInput
                                            labelWidth={70}
                                            name="Company"
                                            id="outlined-age-simple"
                                            readOnly={view_type === 'detail'}
                                        />
                                    }
                                >
                                    <MenuItem value={0}>
                                        <em>None</em>
                                    </MenuItem>
                                    {companyItems}
                                </Select>
                            </FormControl>
                        </Grid>
                    </form>
                </Grid>
                <Grid item xs={6}>
                    <ComponentTrackingInfo
                        editInfo={this.props.editInfo}
                        view_type={this.props.view_type}
                        classes={classes}
                    />
                </Grid>
            </Grid >
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getQualification: Actions.getQualification,
        updateQualificationForm: Actions.updateQualificationForm,
        runValidator: validatorActions.runValidator,
    }, dispatch);
}

function mapStateToProps({ qualificationApp, auth, validator, companyApp }) {
    return {
        currentQualification: qualificationApp.qualifications.currentQualification,
        auth,
        validator: validator.list,
        editInfo: qualificationApp.qualifications.editInfo
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QualificationForm)));



// WEBPACK FOOTER //
// src/main/content/qualification/QualificationForm.js